import CustomHTMLElement from '@onpace/onspace-core/components/html_element'

/// An element which displays toast-style messages on top of the UI.
export default class OnspaceToast extends CustomHTMLElement {
  /// Sets up the toast element.
  ///
  /// This supports the following options:
  /// [icon]
  ///   The name of the icon to display within the element.
  /// [text]
  ///   The text to display within the element.
  runConstructor(options = {}) {
    super.runConstructor()

    this.classList.add('onspace-toast')

    if (options.icon) {
      const iconElement = SVGElement.createOnspaceSpritemapSvg(options.icon)
      iconElement.classList.add('onspace-toast__icon')
      this.appendChild(iconElement)
    }

    if (options.text) {
      const textElement = document.createElement('div')
      textElement.classList.add('onspace-toast__text')
      textElement.innerText = options.text
      this.appendChild(textElement)
    }

    if (options.color) {
      this.classList.add(`onspace-toast--color-${options.color}`)
    }
  }

  ////////// State

  /// Indicates if the toast is currently visible.
  get visible() {
    return this.classList.contains('onspace-toast--visible')
  }

  /// Displays the toast.
  ///
  /// This returns a promise that resolves once the show animation completes.
  show() {
    return new Promise((resolve, _reject) => {
      if (this.visible) {
        resolve()
        return
      }

      const animationEnded = (_event) => {
        this.removeEventListener('animationend', animationEnded)
        this.triggerEvent('onspace:toast:show')

        resolve()
      }

      document.body.appendChild(this)
      this.classList.add('onspace-toast--visible')
      this.addEventListener('animationend', animationEnded)
    })
  }

  /// Closes the toast.
  ///
  /// This returns a promise that resolves once the animation completes.
  hide() {
    return new Promise((resolve, _reject) => {
      if (!this.visible) {
        resolve()
        return
      }

      const animationEnded = (_event) => {
        this.removeEventListener('animationend', animationEnded)
        this.triggerEvent('onspace:toast:hide')
        this.remove()

        resolve()
      }

      this.classList.remove('onspace-toast--visible')
      this.addEventListener('animationend', animationEnded)
    })
  }
}

window.customElements.define('onspace-toast', OnspaceToast)
